import {useCanEditColors} from '../hooks'

import {ColorPreview} from './ColorPreview'
import {ColorSelector} from './ColorSelector'

interface LocalColorCellProps {
  globalColor: string
  localColor?: string
  onColorChange: (color: string) => void
  dataCy?: string
}

export const LocalColorCell: React.FC<LocalColorCellProps> = ({
  globalColor,
  localColor,
  onColorChange,
  dataCy = 'local-color'
}) => {
  const canEditColors = useCanEditColors()

  if (!canEditColors) {
    return <ColorPreview color={localColor ?? globalColor} dataCy={`${dataCy}-preview`} />
  }

  return (
    <ColorSelector
      defaultColor={globalColor}
      customColor={localColor}
      showResetButton={false}
      showDefaultColorAsFallback={true}
      showSelectedOutline={false}
      isDisabled={!canEditColors}
      onColorChange={onColorChange}
      dataCy={dataCy}
    />
  )
}
